import React from "react";
import { Col, Row } from "react-bootstrap";
import vsCodeLogo from "../../Assets/visualstudiocode.svg"; // save SVG in Assets folder
import { SiEclipseide, SiAnaconda, SiJupyter, SiPostman, SiFigma, SiVercel, SiRender } from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <img src={vsCodeLogo} alt="VS Code" title="Visual Studio Code" style={{ width: "50px", height: "50px" }} />
      </Col>
      <Col xs={4} md={2} className="tech-icons"><SiEclipseide title="Eclipse IDE" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiAnaconda title="Anaconda Navigator" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiJupyter title="Jupyter Notebook" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiPostman title="Postman API Client" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiFigma title="Figma (UI/UX Design)" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiVercel title="Vercel Deployment" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiRender title="Render Deployment" /></Col>
    </Row>
  );
}

export default Toolstack;
